"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.page404WithoutContext = void 0;
// eslint-disable-next-line import/prefer-default-export
var page404WithoutContext = {
  name: '404',
  url: '/404',
  metaTitlePhrase: undefined,
  breadcrumbs: [{
    phrase: ['Common', 'breadcrumb.homepage.text'],
    url: '/'
  }]
};
exports.page404WithoutContext = page404WithoutContext;